import { render, staticRenderFns } from "./auth2.vue?vue&type=template&id=56044f50&"
import script from "./auth2.vue?vue&type=script&lang=js&"
export * from "./auth2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports